import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { FORM } from "helpers/validations";
import Input from "components/shared/input/Input";

import {
    QuantityInputStyled,
    Container,
    Left,
    Right,
    Button
} from "./QuantityInput.styled";

function QuantityInput({ id, name, hasMinimum }) {
    const { register, unregister, errors, setValue, watch } = useFormContext();
    const fieldValue = watch(name, 0);

    function handleDecrement() {
        const currentValue = Number(fieldValue);

        if (currentValue > 0) {
            setValue(name, `${currentValue - 1}`, { shouldDirty: true });
        }
    }

    function handleIncrement() {
        setValue(name, `${Number(fieldValue) + 1}`, { shouldDirty: true });
    }

    function setQuantity({ target }) {
        setValue(name, `${Number(target.value)}`, { shouldDirty: true });
    }

    useEffect(() => {
        const QuantityValidation = hasMinimum
            ? {
                  ...FORM.QUANTITY,
                  validate: {
                      minimum: value =>
                          Number(value) > 0 || "Aantal mag niet 0 zijn"
                  }
              }
            : { ...FORM.QUANTITY, required: false };
        register({ name }, { ...QuantityValidation });
    }, [register, unregister, name, hasMinimum, setValue, fieldValue]);

    useEffect(() => {
        setValue(name, `${Number(fieldValue)}`);
    }, [fieldValue, setValue, name]);

    return (
        <QuantityInputStyled>
            <Left>
                <Button
                    type="button"
                    aria-label="decrement button"
                    onClick={handleDecrement}
                >
                    <img
                        src="/images/icon-minus.svg"
                        width={21}
                        height={21}
                        alt="Aantal verlagen"
                        loading="lazy"
                    />
                </Button>
            </Left>
            <Container>
                <Input
                    id={id}
                    name={name}
                    type="number"
                    inputMode="numeric"
                    aria-label="aantal invoerveld"
                    value={fieldValue}
                    onChange={setQuantity}
                    placeholder={0}
                    errorMessageWidth="260px"
                    errorMessage={errors[name]?.message}
                />
            </Container>
            <Right>
                <Button
                    type="button"
                    aria-label="increment button"
                    onClick={handleIncrement}
                >
                    <img
                        src="/images/icon-plus.svg"
                        alt="Aantal verhogen"
                        width={21}
                        height={21}
                        loading="lazy"
                    />
                </Button>
            </Right>
        </QuantityInputStyled>
    );
}

QuantityInput.defaultProps = {
    hasMinimum: false,
    id: undefined
};

QuantityInput.propTypes = {
    hasMinimum: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string.isRequired
};

export default QuantityInput;
